import React from 'react';
import App from './App';
import { getRenderData } from '@/utils/get-render-data';
import { AppContextProvider } from '@/context/AppContext';
import { getOrCreateReactRoot } from '@/utils/get-or-create-react-root';

/**
 * Listen for a custom event to re-trigger the render function.
 * This should be considered a last resort and only used when absolutely
 * necessary to work around "Rails magic" (e.g. when using show.js.erb
 * we manually update the DOM using jQuery with
 * <%= escape_javascript(render('message_display')) %>).
 */
document.addEventListener('squarekit_app_force_rerender', render);

export default function render() {
  const id = 'react-app-root';
  const el = document.getElementById(id);
  if (!el) {
    throw new Error(`#${id} element not found`);
  }

  const data = getRenderData.parse(el?.dataset?.appContext);
  const root = getOrCreateReactRoot(el);

  root.render(
    <React.StrictMode>
      <AppContextProvider value={data}>
        <App />
      </AppContextProvider>
    </React.StrictMode>
  );
}
